module.exports = __webpack_public_path__ + "static/media/gas_cylinder.4ab868f0.png";